"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGraphClient = (accessToken) => {
    const getCurrentUserInfo = () => exports.callGraphApi('/v1.0/me/', accessToken);
    const getCurrentUserPhoto = (size) => exports.callGraphApi(`/v1.0/me/photos/${size}x${size}/$value`, accessToken, 'blob');
    const getCurrentUserPhotoDataUrl = async (size) => {
        const photoBlob = await getCurrentUserPhoto(size);
        return await convertBlobToDataUrl(photoBlob);
    };
    return {
        getCurrentUserInfo,
        getCurrentUserPhoto,
        getCurrentUserPhotoDataUrl
    };
};
exports.callGraphApi = (url, accessToken, responseType = 'json') => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.addEventListener('load', () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                if (responseType === 'json')
                    resolve(JSON.parse(xhr.responseText));
                else
                    resolve(xhr.response);
            }
            else {
                reject(xhr.statusText);
            }
        });
        xhr.addEventListener('error', () => reject(xhr.statusText));
        xhr.open('GET', 'https://graph.microsoft.com' + url, true);
        // IE doesn't support reponseType json so we deal with that manually :(
        xhr.responseType = responseType == 'json' ? 'text' : responseType;
        xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken);
        xhr.send();
    });
};
const convertBlobToDataUrl = (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result); // Note: ArrayBuffer isn't relevant here
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};
exports.default = exports.createGraphClient;
